import ChangePassword from '../../components/common/ChangePassword'

export default function ChangePasswordPage() {
  return (
    <div>
      <h1 style={{ fontSize: 24, margin: '0 0 24px' }}>Passwort ändern</h1>
      <ChangePassword />
    </div>
  )
}
